import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AppProvider, useApp } from "@/context/AppContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import SearchPage from "@/pages/SearchPage";
import Identity from "@/pages/Identity";
import ImagePage from "@/pages/ImagePage";
import AirPage from "@/pages/AirPage";
import Cyber from "@/pages/Cyber";
import Assistant from "@/pages/Assistant";
import Dossiers from "@/pages/Dossiers";
import DossierDetail from "@/pages/DossierDetail";
import Admin from "@/pages/Admin";
import Sources from "@/pages/Sources";
import Monitor from "@/pages/Monitor";
import GraphPage from "@/pages/GraphPage";
import GeoPage from "@/pages/GeoPage";

function Protected({ children, roles }) {
  const { user } = useApp();
  if (user === null)
    return <div className="h-screen grid place-items-center eyebrow" data-testid="auth-loading">Vérification de la session…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/identity" element={<Identity />} />
        <Route path="/image" element={<ImagePage />} />
        <Route path="/air" element={<AirPage />} />
        <Route path="/cyber" element={<Cyber />} />
        <Route path="/ai" element={<Assistant />} />
        <Route path="/dossiers" element={<Dossiers />} />
        <Route path="/dossiers/:id" element={<DossierDetail />} />
        <Route path="/sources" element={<Sources />} />
        <Route path="/monitor" element={<Monitor />} />
        <Route path="/graph" element={<GraphPage />} />
        <Route path="/geo" element={<GeoPage />} />
        <Route path="/admin" element={<Protected roles={["admin"]}><Admin /></Protected>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AppProvider>
      <TooltipProvider delayDuration={200}>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster richColors position="bottom-right" />
      </TooltipProvider>
    </AppProvider>
  );
}
